import { v4 as UUID } from 'uuid';
import URLSafeBase64 from 'urlsafe-base64';

export default function generateId() {
  // eslint-disable-next-line
  const buffer = Buffer.alloc(16);
  UUID({}, buffer);
  return URLSafeBase64.encode(buffer);
}
